export enum SessionStatus {
  NEW,
  ACTIVE,
  CLOSED,
}
